/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetTunneledMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetTunneledMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetTunneledMcpServerSecurity = {
  option1?: GetTunneledMcpServerSecurityOption1 | undefined;
  option2?: GetTunneledMcpServerSecurityOption2 | undefined;
};

export type GetTunneledMcpServerRequest = {
  /**
   * The ID of the tunneled MCP server
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetTunneledMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetTunneledMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  GetTunneledMcpServerSecurityOption1$Outbound,
  GetTunneledMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getTunneledMcpServerSecurityOption1ToJSON(
  getTunneledMcpServerSecurityOption1: GetTunneledMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    GetTunneledMcpServerSecurityOption1$outboundSchema.parse(
      getTunneledMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type GetTunneledMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetTunneledMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  GetTunneledMcpServerSecurityOption2$Outbound,
  GetTunneledMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getTunneledMcpServerSecurityOption2ToJSON(
  getTunneledMcpServerSecurityOption2: GetTunneledMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    GetTunneledMcpServerSecurityOption2$outboundSchema.parse(
      getTunneledMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type GetTunneledMcpServerSecurity$Outbound = {
  Option1?: GetTunneledMcpServerSecurityOption1$Outbound | undefined;
  Option2?: GetTunneledMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetTunneledMcpServerSecurity$outboundSchema: z.ZodMiniType<
  GetTunneledMcpServerSecurity$Outbound,
  GetTunneledMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetTunneledMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetTunneledMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getTunneledMcpServerSecurityToJSON(
  getTunneledMcpServerSecurity: GetTunneledMcpServerSecurity,
): string {
  return JSON.stringify(
    GetTunneledMcpServerSecurity$outboundSchema.parse(
      getTunneledMcpServerSecurity,
    ),
  );
}

/** @internal */
export type GetTunneledMcpServerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetTunneledMcpServerRequest$outboundSchema: z.ZodMiniType<
  GetTunneledMcpServerRequest$Outbound,
  GetTunneledMcpServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getTunneledMcpServerRequestToJSON(
  getTunneledMcpServerRequest: GetTunneledMcpServerRequest,
): string {
  return JSON.stringify(
    GetTunneledMcpServerRequest$outboundSchema.parse(
      getTunneledMcpServerRequest,
    ),
  );
}
